import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47cd6b8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "abilities-card__header d-flex align-items-start mb-6" }
const _hoisted_4 = { class: "card-title mb-2 abilities-card__title" }
const _hoisted_5 = { class: "abilities-card__subtitle mb-0" }
const _hoisted_6 = { class: "abilities-card__layout" }
const _hoisted_7 = {
  key: 0,
  class: "skills-summary mt-2"
}

import { computed, onBeforeMount, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import AbilitiesRadarGraphic from "@/modern/components/ui/AbilitiesRadarGraphic.vue";
import { dashboardService } from "@/modern/services/dashboardService";
import type { ModernCategory } from "@/modern/types/dashboard";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const { t } = useI18n();
const currentLanguage = computed(
	() => store.getters.getCurrentLanguage || localStorage.getItem("currentLanguage") || "en"
);

const categories = ref<ModernCategory[]>([]);
const allCategories = ref<ModernCategory[]>([]);
const selectedCategoryIds = ref<number[]>([]);
const loading = ref(true);
const filtering = ref(false);

const fetchOwnedCategoriesWithTimeout = async (ids: number[], timeoutMs = 15000) => {
	return Promise.race<ModernCategory[]>([
		dashboardService.fetchOwnedCategories(ids),
		new Promise<ModernCategory[]>((_, reject) => {
			setTimeout(() => reject(new Error("Filter request timeout")), timeoutMs);
		}),
	]);
};

onBeforeMount(async () => {
	try {
		allCategories.value = await dashboardService.fetchAllCategories();
		categories.value = await dashboardService.fetchOwnedCategories();
		selectedCategoryIds.value = categories.value.map((category) => category.id);
	} catch (error) {
		console.error("Error loading categories:", error);
	} finally {
		loading.value = false;
	}
});

const handleApplyFilter = async () => {
	if (selectedCategoryIds.value.length !== 5 || filtering.value) {
		return;
	}

	filtering.value = true;
	try {
		categories.value = await fetchOwnedCategoriesWithTimeout(selectedCategoryIds.value);
	} catch (error) {
		console.error("Error filtering categories:", error);
	} finally {
		filtering.value = false;
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.page_dashboard.your_abilities`)), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(categories.value.length) + "/5", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(AbilitiesRadarGraphic, {
          "categories-data": categories.value,
          "all-categories-data": allCategories.value,
          "selected-category-ids": selectedCategoryIds.value,
          "current-language": _unref(currentLanguage),
          loading: loading.value,
          filtering: filtering.value,
          "loading-label": _unref(t)(`${_unref(currentLanguage)}.common.loading`),
          "onUpdate:selectedCategoryIds": _cache[0] || (_cache[0] = ($event: any) => (selectedCategoryIds.value = $event)),
          onApplyFilter: handleApplyFilter
        }, null, 8, ["categories-data", "all-categories-data", "selected-category-ids", "current-language", "loading", "filtering", "loading-label"]),
        (!loading.value && categories.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: category.id
                }, _toDisplayString(category.name) + ": " + _toDisplayString(Number(category.percentage).toFixed(0)), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})